/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__TitleInputs */

const en_help_center__refund_policy__title = /** @type {(inputs: Help_Center__Refund_Policy__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund Policy`)
};

/**
* | output |
* | --- |
* | "Refund Policy" |
*
* @param {Help_Center__Refund_Policy__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__title = /** @type {((inputs?: Help_Center__Refund_Policy__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__refund_policy__title(inputs)
});